<template>
<div>
    <!-- =============================================================================== -->

    <v-row justify="center">
            <v-dialog v-model="$store.state.showDialogGuia.guia" max-width="600px" persistent>
              <v-card>
                <v-card-title>
                  <span class="headline">Guia de transferência</span>
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="12" sm="6" md="12">
                           <v-card-title>
                              <span class="headline">Selecionar a instituição a transferir</span>
                          </v-card-title>
                      </v-col>

                      <v-col cols="12" sm="12">
                        <v-autocomplete
                  v-model="instituicao"
                  :items="instituicoes"
                  :search-input.sync="search"
                  color="primary"
                  item-text="descricao"
                  item-value="idInstituicao"
                  label="Pesquise aqui"
                  placeholder="Selecione a instituição a transferir"
                  prepend-icon="mdi-database-search"
                  return-object
                  outlined
                ></v-autocomplete>

                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="red darken-1" text @click="sair()">Cancelar</v-btn>
                   <v-btn :disabled="instituicao !== null && instituicao.idInstituicao > 0" color="blue darken-1" text @click="carregarRelatorio()">Vizualizar</v-btn>
                 </v-card-actions>
              </v-card>
            </v-dialog>
          </v-row>

  <!--================================================================================== -->
</div>
</template>
<script>
import axios from '../../../plugins/axios'
import Swal from 'sweetalert2'
const ls = require('local-storage')
export default {
  data: () => ({
    search: null,
    instituicao: { idInstituicao: 0, descricao: '' },
    instituicoes: [],
    instituicoesfilter: [],
    estudante: null,
    relatorio: ls.get('relatorio-estudante'),
    html: ``,
    titulo: '',
    classes: [
      '10ª Classe',
      '11ª Classe',
      '12ª Classe',
      '13ª Classe'
    ]
  }),
  computed: {
    showDialogGuia () {
      return this.$store.state.showDialogGuia.guia
    }
  },
  watch: {

    search (val) {
      if (val.length > 3) {
        this.instituicoesfilter = this.instituicoes.filter(t => t.descricao.includes(val))
        if (!(this.instituicoesfilter.length)) {
          this.instituicoesfilter = []
        }
        return this.instituicoesfilter
      }
    }

  },
  created  () {
    this.estudante = this.$store.state.objAluno
    this.initializeInstituicao()
  },
  methods: {
    async initializeInstituicao () {
      try {
        this.instituicoes = await axios
          .get('/listarInstituicao')
          .then(res => res.data)
        this.instituicoes = this.instituicoes.filter(t => t.idInstituicao !== ls.get('i_id') && t.idInstituicao !== 5)
      } catch (error) {
        this.sair()
        Swal.fire({
          icon: 'error',
          title: '',
          text: 'Ocorreu um erro ao carregar as instituições'
        })
      }
    },
    async carregarRelatorio () {
      this.$store.state.isloading = true
      try {
        let guia = await axios
          .get('/obterRelatorio/' + this.relatorio.id)
          .then(res => res.data)
        this.titulo = 'A Guia de Transferência'
        this.comporGuiaTransferencia(guia)
      } catch (error) {
        this.sair()
        Swal.fire({
          icon: 'error',
          title: '',
          text: 'Ocorreu um erro ao carregar o relatório'
        })
      }
    },
    async comporGuiaTransferencia (guia) {
      try {
        this.$store.state.showDialogGuia.guia = false
        let documento = guia[0].documento
        let declaracao = guia[0].documentoiteracao1
        let classe = this.estudante.idAno_Academico - 1
        let declaracaoiteracao = ''
        documento = documento.replace(/{{numeroguia}}/g, '')
        documento = documento.replace(/{{curso}}/g, this.estudante.curso.toUpperCase())
        documento = documento.replace(/{{logotipoInstituicao}}/g, ls.get('insignia'))
        documento = documento.replace(/{{instituicaocabecalho}}/g, ls.get('instituicaodescricao').toUpperCase())
        documento = documento.replace(/{{instituicao}}/g, ls.get('instituicaodescricao'))
        documento = documento.replace(/{{instituicaodestinocabecalho}}/g, (this.instituicao.descricao).toUpperCase())
        documento = documento.replace(/{{instituicaodestino}}/g, this.instituicao.descricao)
        documento = documento.replace(/{{nomeAluno}}/g, this.estudante.nome.toUpperCase())
        documento = documento.replace(/{{nomedopai}}/g, this.estudante.nomedopai)
        documento = documento.replace(/{{nomedamae}}/g, this.estudante.nomedamae)
        documento = documento.replace(/{{municipio}}/g, this.estudante.municipio)
        documento = documento.replace(/{{provincia}}/g, this.estudante.provincia)
        documento = documento.replace(/{{classe}}/g, this.classes[classe])
        const datadenascimento = (this.dataExtensao(this.estudante.datanascimento))
        const datadeemissao = (this.dataExtensaobi(this.estudante.dataemissaobi))
        documento = documento.replace(/{{datanascimento}}/g, (datadenascimento.length ? datadenascimento : ''))
        documento = documento.replace(/{{dataemissaobi}}/g, (datadeemissao.length ? datadeemissao : ''))
        documento = documento.replace(/{{bi}}/g, this.estudante.bi)
        documento = documento.replace(/{{dataactual}}/g, this.dataActual())
        for (let index = 0; index < classe; index++) {
          declaracaoiteracao += declaracao.replace(/{{classe}}/g, this.classes[index])
        }
        documento = documento.replace(/{{declaracao}}/g, declaracaoiteracao)
        this.html = documento
        let options = {
          'format': 'A4',
          'border': {
          // default is 0, units: mm, cm, in, px
            'right': '15mm',
            'left': '15mm'
          },
          'header': {
            'height': '10mm',
            'contents': { first: `<table width="100%" class="tablecabecalho">
               <tr class="center tablecabecalho"><td width="90%" class="tablecabecalho"> </td> <td class="tablecabecalho">Visto</td></tr>   
               <tr class="center tablecabecalho"><td width="90%" class="tablecabecalho"> </td> <td class="tablecabecalho">O(A) Director(a) Geral I.T.S.L</td></tr>
               <tr class="tablecabecalho"><td width="90%" class="tablecabecalho"> </td> <td class="tablecabecalho">_________________________________</td></tr>
               <tr class="center tablecabecalho"><td width="90%" class="tablecabecalho"> </td> <td class="tablecabecalho">Francisca Manuela Manjenje Boavida</td></tr>
               <tr class="center tablecabecalho"><td width="90%" class="tablecabecalho"> </td> <td class="tablecabecalho">"Enfermeira Especialista"</td></tr>
          </table>` }
          },
          'footer': {
            'height': '8mm'
          } }
        this.gerarPdf(options)
      } catch (error) {
        this.sair()
        Swal.fire({
          icon: 'error',
          title: '',
          text: 'Ocorreu um erro ao carregar ao compor o relatório'
        })
      }
    },
    async gerarPdf (option) {
      try {
        await axios({
          method: 'post',
          url: ls.get('urlReport') + 'writefile',
          data: {
            html: this.html,
            file_name: ls.get('idPessoa'),
            option: option
          }
        }).then((res) => res.data)
        this.frame()
      } catch (error) {
        this.sair()
        Swal.fire({
          icon: 'error',
          title: '',
          text: 'Ocorreu um erro'
        })
      }
    },
    frame () {
      this.sair()
      let readfile = ls.get('urlReport') + 'readfile/' + ls.get('idPessoa') + '.pdf'
      let frame = `<html> +
      <style>html, body { padding: 0; margin: 0; } iframe { width: 100%; height: 100%; border: 0;}  </style> 
      <body>
      <iframe target="_blank" type="application/pdf" src="` + readfile + `"></iframe> 
      </body></html>`
      let a = window.open('about:blank', '_blank', '', true)
      a.document.write(frame)
      a.document.close()
    },
    sair () {
      this.$store.state.isloading = false
      this.$store.state.showDialogGuia.guia = false
    },
    dataActual () {
      let data = new Date()
      var month = []
      month[0] = 'Janeiro'
      month[1] = 'Fevereiro'
      month[2] = 'Março'
      month[3] = 'Abril'
      month[4] = 'Maio'
      month[5] = 'Junho'
      month[6] = 'Julho'
      month[7] = 'Agosto'
      month[8] = 'Setembro'
      month[9] = 'Outubro'
      month[10] = 'Novembro'
      month[11] = 'Dezembro'
      return data.getDate().toString() + ' de ' + month[(data.getMonth())] + ' de ' + data.getFullYear().toString()
    },
    dataExtensao (dateString) {
      // dateString = dateString.split('/')
      dateString = dateString.split('-')
      var month = []
      month[0] = 'Janeiro'
      month[1] = 'Fevereiro'
      month[2] = 'Março'
      month[3] = 'Abril'
      month[4] = 'Maio'
      month[5] = 'Junho'
      month[6] = 'Julho'
      month[7] = 'Agosto'
      month[8] = 'Setembro'
      month[9] = 'Outubro'
      month[10] = 'Novembro'
      month[11] = 'Dezembro'
      return dateString[0] + ' de ' + month[parseInt(dateString[1]) - 1] + ' de ' + dateString[2]
    },
    dataExtensaobi (dateString) {
      // dateString = dateString.split('/')
      dateString = dateString.split('-')
      var month = []
      month[0] = 'Janeiro'
      month[1] = 'Fevereiro'
      month[2] = 'Março'
      month[3] = 'Abril'
      month[4] = 'Maio'
      month[5] = 'Junho'
      month[6] = 'Julho'
      month[7] = 'Agosto'
      month[8] = 'Setembro'
      month[9] = 'Outubro'
      month[10] = 'Novembro'
      month[11] = 'Dezembro'
      return dateString[0] + ' de ' + month[parseInt(dateString[1]) - 1] + ' de ' + dateString[2]
    }
  }
}

</script>
